<template>
    <div class="Simulator_actions-container right-content__cta-container">
        <button 
            v-if="displaySecondBtn"
            @click="triggerSecondAction()"
            class="btn btn-hidden_text"
        >
            <i class="icon-arrow-2"></i>
            <span class="btn-label">{{ btnSecondLabel }}</span>
        </button>
        
        <button 
            v-if="displayPrimaryBtn"
            class="btn btn--red btn--fill btn-primary_chevron"
            @click="triggerPrimaryAction()"
        >
            <span class="btn-label">{{ btnPrimaryLabel }}</span>
            <i class="icon-arrow-2"></i>
        </button>
    </div>
</template>

<script>




export default {
    name: "ActionsButtons",

    components: {

    },

    props: {
        currentQuestionIndex: {
            type: Number,
            default: 0
        },

        displayPrimaryBtn: {
            type: Boolean,
            default: true,
        },

        btnPrimaryLabel: {
            type: String,
            default: "Continuer",
        },

        displaySecondBtn: {
            type: Boolean,
            default: true,
        },

        btnSecondLabel: {
            type: String,
            default: "Retour",
        },
    },

    methods: {
        triggerPrimaryAction() {
            this.$emit('primaryBtn::action');
        },

        triggerSecondAction() {
            this.$emit('secondBtn::action');
        }
    },
}
</script>

<style lang="scss">
.Simulator_actions-container {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 100%;
    display: flex;
    padding: 10px 20px;
    justify-content: space-between;
    box-shadow: 0 0 20px rgb(12 35 44 / 10%);

    @include breakpoint(only-md) {
        background: $color-white;
    }
    

    @include breakpoint(md) {
        position: relative;
        box-shadow: none;
    }


    .btn-primary_chevron {
        //Alone align end
        margin-left: auto;
    }
}
</style>